import { makeStyles } from 'tss-react/mui'

import { hubloTheme } from '@front/theme'

export const useCircularLoadingStyles = makeStyles()(() => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',

    '& .MuiCircularProgress-circleIndeterminate': {
      strokeDasharray: '100px, 200px',
    },
  },

  absolute: {
    position: 'absolute',
  },

  normalIndicator: {
    color: hubloTheme.palette.common.blue15,
  },
  whiteIndicator: {
    color: hubloTheme.palette.common.white,
  },
  secondaryIndicator: {
    color: hubloTheme.palette.common.blue15,
  },

  circle: {
    animationDuration: '800ms',
  },
  normalCircle: {
    color: hubloTheme.palette.common.blue5,
  },
  primaryCircle: {
    color: hubloTheme.palette.common.blue10,
  },
  secondaryCircle: {
    color: hubloTheme.palette.common.blue5,
  },
  secondaryDarkBgCircle: {
    color: hubloTheme.palette.common.blue10,
  },
  deleteCircle: {
    color: hubloTheme.palette.common.red10,
  },
}))
